import { Icon, IconProps } from '@chakra-ui/react';

export function ArrowForwardIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="21"
      height="32"
      viewBox="0 0 21 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20.5303 16.5303C20.8232 16.2374 20.8232 15.7626 20.5303 15.4697L15.7574 10.6967C15.4645 10.4038 14.9896 10.4038 14.6967 10.6967C14.4038 10.9896 14.4038 11.4645 14.6967 11.7574L18.9393 16L14.6967 20.2426C14.4038 20.5355 14.4038 21.0104 14.6967 21.3033C14.9896 21.5962 15.4645 21.5962 15.7574 21.3033L20.5303 16.5303ZM0 16.75H20V15.25H0V16.75Z" />
    </Icon>
  );
}
